"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var react_redux_1 = require("react-redux");
require("@draft-js-plugins/mention/lib/plugin.css");
var react_redux_firebase_1 = require("react-redux-firebase");
var queries_1 = require("utils/firebase/queries");
var populated_1 = require("utils/selectors/populated");
var single_1 = require("utils/selectors/single");
var CommentEditor_1 = __importDefault(require("./CommentEditor"));
var CommentView_1 = __importDefault(require("./CommentView"));
var ToolChatWrapper = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var theme = _a.theme;
    return ({
        borderTop: "1px solid ".concat(theme.palette.grey[400]),
        borderBottom: "1px solid ".concat(theme.palette.grey[400]),
        padding: theme.spacing(1, 0),
        margin: theme.spacing(1, 0, 8, 0),
    });
});
var ToolChat = function (_a) {
    var serviceId = _a.serviceId;
    var myCompany = (0, react_redux_1.useSelector)(single_1.selectMyCompany);
    var comments = (0, react_redux_1.useSelector)((0, populated_1.makeSelectPopulatedServiceComments)(serviceId));
    (0, react_redux_firebase_1.useFirestoreConnect)(function () { return [
        (0, queries_1.commentsForServiceQuery)(serviceId, (myCompany === null || myCompany === void 0 ? void 0 : myCompany.id) || ''),
    ]; });
    return ((0, jsx_runtime_1.jsxs)(ToolChatWrapper, { children: [comments === null || comments === void 0 ? void 0 : comments.map(function (comment) { return (0, jsx_runtime_1.jsx)(CommentView_1.default, { comment: comment }, comment.id); }), (0, jsx_runtime_1.jsx)(CommentEditor_1.default, { serviceId: serviceId })] }));
};
exports.default = ToolChat;
